export default __webpack_public_path__ + "static/media/flexibleWorkHours.e931c73e.svg";